// @flow

export const getIsUserBidBigEnough = (
  minUserBid: number,
  userBid: number
): boolean => {
  return userBid >= minUserBid
}

export const getCanUserBidDecrease = (
  minUserBid: number,
  userBid: number
): boolean => {
  return userBid > minUserBid
}

type Item = { currentBidAmount: number, initialBid: number }

export const getMinIncrementAmount = (
  item: Item,
  incrementPercentage: number,
  limitAmount: number
): number => {
  const increment = Math.ceil(item.initialBid * incrementPercentage)
  return limitAmount && increment > limitAmount ? limitAmount : increment
}

export const getMinIncrementPercentageText = (
  incrementPercentage: number
): string => `${incrementPercentage * 100}%`

export const getIsInitialBid = (item: Item): boolean => !item.currentBidAmount

export const getMinUserBid = (item: Item, incrementAmount: number): number =>
  getIsInitialBid(item)
    ? item.initialBid
    : item.currentBidAmount + incrementAmount



// WEBPACK FOOTER //
// ./src/services/bid/utils.js